import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as CloseSVG } from 'Images/icon-close-without-background.svg';
import { ReactComponent as RiskAcceptedSVG } from 'Images/icon-list-confirmed.svg';
import { ReactComponent as ReOpenedSVG } from 'Images/icon-warning-triangle.svg';
import { ReactComponent as UserSVG } from 'Images/icon_users.svg';
import { ReactComponent as DateSVG } from 'Images/calendar.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 18px 0 21px;
  background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
  margin-top: 22px;
  overflow: auto;
  border-radius: 5px;
`;
Wrapper.displayName = 'Wrapper';

export const Item = styled.div`
  display: flex;
  margin-bottom: 20px;
  width: 100%;
  height: 80px;
`;
Item.displayName = 'Item';

export const Box = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.backgrounds.sidebar};
  border-radius: 5px;
  width: 100%;
  margin-left: 20px;
  padding: 14px 14px 7px 20px;
`;
Box.displayName = 'Box';

export const Status = styled.div`
  font-size: 14.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.card};
  width: 105px;
  margin-right: 25px;
`;
Status.displayName = 'Status';

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`;
Info.displayName = 'Info';

export const UserIcon = styled(UserSVG)`
  cursor: default;
  margin-right: 11px;
  & > g {
    & :last-child {
      fill: ${({ theme }) => theme.text.tab};
    }
  }
`;
UserIcon.displayName = 'UserIcon';

export const DateIcon = styled(DateSVG)`
  cursor: default;
  margin-right: 11px;
  width: 20px;
  height: 20px;
  path {
    stroke: ${({ theme }) => theme.text.tab};
  }
`;
DateIcon.displayName = 'DateIcon';

export const InfoWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`;
InfoWrapper.displayName = 'InfoWrapper';

export const User = styled.div`
  color:  ${({ theme }) => theme.text.tab};
  font-size: 14.5px;
  font-weight: 500;
`;
User.displayName = 'User';

export const Date = styled.div`
  color: ${({ theme }) => theme.text.card};
  font-size: 14.5px;
`;
Date.displayName = 'Date';

export const Icon = styled.div`
  width: 20px;
  height: 20px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'CentraNo2';
`;
Icon.displayName = 'Icon';

export const New = styled(Icon)`
  background-color: ${colors.blueCerulean};
  border-radius: 4px;
  &:after {
    content: 'N';
    color: #fcfcfc;
  }
`;
New.displayName = 'New';

export const Open = styled(Icon)`
  background-color: ${colors.warmPurple};
  border-radius: 4px;
    &:after {
    content: '!';
    color: #fcfcfc;
    font-size: 12px;
  }
`;
Open.displayName = 'Open';

export const CloseIcon = styled(CloseSVG)`
  width: 12px;
  height: 12px;
  position: absolute;
  left: 4px;
  top: 4px;
  margin: auto;
  cursor: default;
  & g {
    & path{
      fill: ${colors.white};
    }  
  }
`;
CloseIcon.displayName = 'CloseIcon';

export const Closed = styled.div`
  flex: 0 0 20px;
  position: relative;
  padding-left: 3px;
  height: 20px;
  width: 20px;
  cursor: pointer;
  background-color: ${colors.blueGrey};
  border-radius: 50%; 
`;
Closed.displayName = 'Closed';

export const ReOpened = styled(ReOpenedSVG)`
  fill: ${colors.tangerine};
  width: 20px;
  height: 20px;
`;
ReOpened.displayName = 'ReOpened';

export const RiskAccepted = styled(RiskAcceptedSVG)`
  cursor: default;
  width: 20px;
  height: 20px;
  & circle {
    fill: ${colors.apple};
  }
`;
RiskAccepted.displayName = 'RiskAccepted';
